import { getAuthCookie } from '@/analytics/identity/auth.client';
import { getUrl } from '@/core/utils/string';

class AuthLink extends HTMLElement {
	async connectedCallback(): Promise<void> {
		const isAuthenticated = await getAuthCookie();

		if (!isAuthenticated) return;

		const span = this.getElementsByTagName('span').item(0);

		if (!span) return;

		const title = 'My Account';

		span.textContent = title;
		const anchor = this.getElementsByTagName('a').item(0);

		if (!anchor) return;

		anchor.title = title;
		anchor.href = getUrl('my-account', true);
	}
}

function register(): void {
	if (customElements.get('auth-link')) return;
	customElements.define('auth-link', AuthLink);
}

register();
